import type { ButtonStyles } from '../../ThemeTypes';
import colors from '../colors';
import fonts from '../fonts';

const buttons: ButtonStyles = {
  base: {
    borderRadius: '22.5px',
    fontWeight: fonts.fontWeights.bold,
    padding: '0.5rem',
    textDecoration: 'none',
    textTransform: 'none',
    '${max.sm}': {
      fontSize: '14px',
    },
    '&.disabled': {
      cursor: 'not-allowed',
    },
    '&.btn.focus, &.btn:focus': {
      boxShadow: 'none',
    },
  },
  primary: {
    backgroundColor: colors.primary,
    borderColor: colors.primary,
    textTransform: 'none',
    margin: '30px 0 25px',
    '&:hover, &:active, &:focus, &:not(:disabled):not(.disabled):active': {
      backgroundColor: colors.primaryHover,
      borderColor: colors.primaryHover,
    },
    '&.btn-primary.disabled, &.btn-primary:disabled': {
      backgroundColor: colors.primaryHover,
      borderColor: colors.primaryHover,
      opacity: 0.6,
    },
  },
  outlinePrimary: {
    borderColor: colors.primary,
    color: colors.primary,
    textTransform: 'none',
    '&:hover, &:active, &:focus, &:not(:disabled):not(.disabled):active': {
      borderColor: colors.primaryHover,
      backgroundColor: colors.white,
      color: colors.primaryHover,
    },
    '&.btn-primary.disabled, &.btn-primary:disabled': {
      borderColor: colors.primaryHover,
      backgroundColor: colors.white,
      color: colors.primaryHover,
      opacity: 0.6,
    },
  },
  secondary: {
    background: colors.white,
    color: colors.primary,
    textTransform: 'none',
    border: `2px solid ${colors.primary}`,
    '&:hover, &:active, &:focus, &:not(:disabled):not(.disabled):active, .btn-primary.disabled, .btn-primary:disabled':
      {
        background: `${colors.white} !important`,
        borderColor: `${colors.primaryHover} !important`,
        color: `${colors.primaryHover} !important`,
      },
  },
  light: {
    background: 'none',
    color: colors.light,
    textDecoration: 'none',
    textTransform: 'none',
    border: `2px solid ${colors.offWhite}`,
    '&:hover, &:active, &:focus, &:not(:disabled):not(.disabled):active, .btn-primary.disabled, .btn-primary:disabled':
      {
        background: 'none !important',
        border: `2px solid ${colors.offWhite}`,
        color: `${colors.dark} !important`,
      },
  },
  link: {
    background: 'none',
    borderRadius: '0',
    fontWeight: fonts.fontWeights.normal,
    textTransform: 'none',
    textDecoration: 'underline',
    color: colors.primary,
    '&:hover, &:active, &:focus, &:not(:disabled):not(.disabled):active, .btn-primary.disabled, .btn-primary:disabled':
      {
        color: colors.primaryHover,
      },
  },
  inlineLink: {
    background: 'none',
    borderRadius: '0',
    fontWeight: fonts.fontWeights.normal,
    textTransform: 'none',
    textDecoration: 'underline',
    color: colors.primary,
    padding: '0',
    verticalAlign: 'baseline',
    '&:hover, &:active, &:focus, &:not(:disabled):not(.disabled):active, .btn-primary.disabled, .btn-primary:disabled':
      {
        color: colors.primaryHover,
      },
  },
};

export default buttons;
